<template>
  <nav class="flex items-center justify-between flex-wrap bg-indigo-900 p-4">
    <div class="flex items-center flex-shrink-0 text-white mr-6">
      <svg class="mr-2" width="36" height="36" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21.6293 36.8259L21.6262 17.5615L38.3049 27.191L21.6293 36.8259Z" fill="white"/>
        <path d="M51.1057 39.1621C48.3739 44.5766 43.8987 48.9138 38.4013 51.4747C32.9039 54.0356 26.7044 54.6711 20.8017 53.2789C14.899 51.8867 9.63698 48.5477 5.8634 43.8001C2.08982 39.0525 0.0244977 33.1727 0.000216407 27.1081C-0.0240649 21.0435 1.99411 15.1473 5.72955 10.3697C9.465 5.59198 14.7002 2.21102 20.5915 0.771562C26.4828 -0.667894 32.6872 -0.082012 38.205 2.4348C43.7227 4.95162 48.2324 9.25279 51.0075 14.6453L44.2397 18.1281C42.247 14.2558 39.0085 11.1671 35.0463 9.35979C31.084 7.55247 26.6286 7.13175 22.3981 8.16542C18.1675 9.19909 14.4082 11.6269 11.7257 15.0578C9.04333 18.4886 7.59408 22.7227 7.61152 27.0776C7.62896 31.4326 9.11206 35.6549 11.8219 39.0641C14.5317 42.4734 18.3103 44.8711 22.549 45.8708C26.7877 46.8706 31.2396 46.4142 35.1872 44.5752C39.1349 42.7362 42.3485 39.6217 44.3102 35.7336L51.1057 39.1621Z" fill="white"/>
      </svg>
      <!-- <svg class="fill-current h-8 w-8 mr-2" width="54" height="54" viewBox="0 0 54 54" xmlns="http://www.w3.org/2000/svg"><path d="M13.5 22.1c1.8-7.2 6.3-10.8 13.5-10.8 10.8 0 12.15 8.1 17.55 9.45 3.6.9 6.75-.45 9.45-4.05-1.8 7.2-6.3 10.8-13.5 10.8-10.8 0-12.15-8.1-17.55-9.45-3.6-.9-6.75.45-9.45 4.05zM0 38.3c1.8-7.2 6.3-10.8 13.5-10.8 10.8 0 12.15 8.1 17.55 9.45 3.6.9 6.75-.45 9.45-4.05-1.8 7.2-6.3 10.8-13.5 10.8-10.8 0-12.15-8.1-17.55-9.45-3.6-.9-6.75.45-9.45 4.05z"/></svg> -->
      <span class="font-semibold text-xl tracking-tight">Convodo</span>
    </div>
    <div class="block flex-grow flex items-center w-auto">
      <div class="text-sm flex-grow">
        <router-link
        tag='a'
        :to="{name: 'Conversations'}"
        class="mt-0 text-teal-100 hover:text-white mr-6"
        active-class="font-semibold"
        >
          Conversations
        </router-link>
        <router-link
        tag='a'
        :to="{name: 'Integration'}"
        class="mt-0 text-teal-100 hover:text-white mr-6"
        active-class="font-semibold"
        >
          Integration
        </router-link>
      </div>
      <div>
        <button
          class="inline-block text-sm px-4 py-2 leading-none border rounded text-white border-white hover:border-transparent hover:text-teal-500 hover:bg-white mt-0"
          @click="signOut()"
        >
          Signout
        </button>
      </div>
    </div>
  </nav>
</template>

<script>
// import firebase from "firebase";
import firebase from '@/utils/firebase'

export default {

  methods: {
    signOut() {
      firebase.auth().signOut()
        .then(() => {
          this.$router.replace({
            name: "Login"
          });
        })
        .catch(err =>{
          console.log(err)
        })
        ;
    },

  }

}
</script>

<style lang="css" scoped>
  @tailwind utilities;
</style>
